import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useEffect } from "react";

import Axios from "src/helpers/axios";

const LoginGuard = ({ children }) => {
  const navigate = useNavigate();
  const token = Cookies.get("ut");

  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      const user = JSON.parse(localStorage.getItem("user"))
      if (!user) {
        Axios({
          method: "get",
          url: "/api/sso/v1/users/profile",
        })
          .then(({ data }) => {
            if (data) {
              const { roles } = data || {};
              if (roles) {
                let role = roles[0];
                if (role && role.id && role.id === 1) {
                  let dataUser = {
                    id: data?.id,
                    profile: data?.profile,
                    username: data?.username,
                    email: data?.email,
                    role_id: role?.id,
                    role_user: role?.title
                  }
                  localStorage.setItem("user", JSON.stringify(dataUser))
                  Axios({
                    method: "get",
                    url: `/api/tracker/v1/generalsetting`,
                  })
                    .then(({ data: dataGeneralSetting }) => {
                      const dataSettings = dataGeneralSetting?.value;
                      localStorage.setItem("general_setting", JSON.stringify(dataSettings))
                    })
                    .catch((err) => {
                      console.error(err);
                    })
                    .finally(() => {
                      navigate('/')
                    })
                }
              } 
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }, [token])

  if (token) {
    return children;
  }
};

export default LoginGuard;
